export enum TenantFeature {
  ARROW_ICONS = 'ARROW_ICONS',
  DRAWER_MENU = 'DRAWER_MENU',
  DYNAMIC_GRADIENT = 'DYNAMIC_GRADIENT',
  IFRAME_GRADIENT = 'IFRAME_GRADIENT',
  SIMULATE_SPECIALS_OTP_IN_URL = 'SIMULATE_SPECIALS_OTP_IN_URL',
}

export type TenantFeatureType = keyof typeof TenantFeature;
